/*
 * Lightweight auth event bus. The axios interceptor fires `cleared` when a
 * refresh attempt fails; SessionProvider listens and drops its in-memory session
 * so React Router's ProtectedGate redirects to /login on the next render.
 *
 * Using an event bus instead of `window.location.assign('/login')` avoids full
 * page reloads mid-bootstrap and keeps the SW / TanStack Query caches intact.
 */

type AuthEvent = 'cleared';
type Listener = () => void;

const listeners: Record<AuthEvent, Set<Listener>> = {
  cleared: new Set(),
};

export const authEvents = {
  on(event: AuthEvent, fn: Listener): () => void {
    listeners[event].add(fn);
    return () => {
      listeners[event].delete(fn);
    };
  },
  emit(event: AuthEvent): void {
    listeners[event].forEach((fn) => fn());
  },
};
